import client from '../client'
import track from '@/plugins/track'

const defaultPet = [{ name: '', breed: '', dob: '', plan: '', couponCode: '', species: '' }]

export default {
  namespaced: true,
  state: {
    currentStep: 0,
    steps: [{}, {}, {},],
    clinicName: '',
    pets: defaultPet,
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    optIn: true,
    paymentType: '', // card or ACH
    achFullName: '',
    accountNumber: '',
    routingNumber: '',
    bankName: '',
    nameOnCard: '',
    ccNumber: '',
    expMonth: '',
    expYear: '',
    cvv: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
  },
  actions: {
    ADD_PET: function({ commit }, data) {
      commit('addPet', data)
    },
    DELETE_PET: ({ commit }, index) => {
      commit('deletePet', index)
    },
    UPDATE_LAST_PET_PLAN: ({ commit }, plan) => { // used to populate the default pet with the proper plan when clicking sign up from a plan card
      commit('updateLastPetPlan', plan)
    },
    RESET: function({ commit }) {
      commit('reset')
    },
    SET_STEP: ({ commit }, stepNum) => {
      commit('setStep', stepNum)
    },
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SIGNUP: async function ({ commit }) {
      try {
        this.dispatch('loader/CHANGE_STATUS', 'LOADING')
        this.dispatch('loader/CHANGE_DETAIL', 'Purchasing...')
        this.state.signup.mobile = this.state.signup.mobile.replace(/\D/g,'') // Un-masks/strips out non-numeric characters for Mobile number.
        let result = await client.post('/purchase', { ...this.state.signup, clinicName: this.state.selectedPractice.name, recurlyClinicID: this.state.selectedPractice.recurlyClinicID, cc_emails: this.state.selectedPractice.email})
        this.dispatch('loader/CHANGE_STATUS', 'COMPLETE')
        this.dispatch('loader/CHANGE_DETAIL', '')
      }
      catch(err) {
        track({
          event: 'error',
          category: 'error',
          action: 'Signup/Purchase Failed',
          label: 'Signup/Purchase Failed',
        })
        this.dispatch('loader/CHANGE_STATUS', 'ERROR')
        this.dispatch('loader/CHANGE_DETAIL', err.response.data || err)
      }
    },
  },
  getters: {
    isComplete: state => state.currentStep === state.steps.length,
    hasBlankPlan: state => (state.pets[state.pets.length - 1].name === '' && state.pets[state.pets.length - 1].breed === '') || state.pets[state.pets.length - 1].plan === '', // autopopulating the 'Plan' field in add pet looks for this
    pets: state => state.pets,
  },
  mutations: {
    addPet: function(state, data) {
      state.pets.push(data)
    },
    deletePet: function(state, index) {
      state.pets.splice(index, 1)
    },
    reset: function(state) { // resets when a signup button is clicked from plan
      state.pets = defaultPet
      state.pets[state.pets.length - 1].name = ''
      state.pets[state.pets.length - 1].breed = ''
      state.pets[state.pets.length - 1].dob = ''
      state.ccNumber = ''
      state.cvv = ''
      state.expMonth = ''
      state.expYear = ''
    },
    setStep: function(state, stepNum) {
      state.currentStep = stepNum
    },
    setField: function(state, data) {
      state[data.key] = data.value
    },
    updateLastPetPlan: function(state, plan) {
      state.pets = defaultPet
      state.pets[state.pets.length - 1].plan = plan
      state.pets = state.pets.map(pet => pet) // force update
    },
  },
}
